import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import FloatingContact from '@/components/FloatingContact';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
    return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingContact />
    </>
  );
}